<template>
  <div>
    <el-select
      name="country"
      v-model="inputValue"
      filterable
      size="large"
      clearable
      placeholder="Country"
      class="w-100"
    >
      <el-option
        @click="updateValue(item.id)"
        v-for="item in countries"
        :key="item.id"
        :label="item.title"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { useField } from "vee-validate";
import store from "@/store/index";
import { computed, onMounted } from "vue";

export default {
  props: {
    initialValue: {
      type: [Number, String]
    },
    name: {
      type: String,
      required: true
    }
  },
  watch: {
    initialValue() {
      this.inputValue = this.initialValue;
    }
  },
  setup(props, { emit }) {
    const countries = computed(() => store.getters["ListsModule/countries"]);
    onMounted(() => {
      store.dispatch("ListsModule/fetchCountries");
    });
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta
    } = useField(props.name, undefined, {
      initialValue: props.initialValue
    });
    const updateValue = () => {
      emit("change", inputValue.value);
    };
    const setValue = value => {
      inputValue.value = value;
    };
    return {
      updateValue,
      handleChange,
      handleBlur,
      errorMessage,
      inputValue,
      setValue,
      meta,
      countries
    };
  }
};
</script>
